import React from 'react';

import {
  Box,
  Container,
  Drawer,
  DrawerContent,
  Grid,
  GridItem,
  useDisclosure,
} from '@chakra-ui/react';

import Header from './Header';
import Sidebar from './Sidebar';

const Layout = ({ children }: { children: React.ReactNode }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const sidebarWidth = { base: 'full', md: '240px' };

  return (
    <Box
      height={['100dvh', '100vh']}
      display="flex"
      flexDirection="column"
      minW={'100%'}
    >
      <Box position="sticky" top="0" zIndex="sticky">
        <Header onOpen={onOpen} />
      </Box>

      {/* Main Content Area */}
      <Box flex="1" display="flex" width={'100%'}>
        <Grid
          templateColumns={{ base: '1fr', md: `${sidebarWidth.md} 1fr` }}
          height="100%"
          width={'100%'}
        >
          {/* Desktop Sidebar */}
          <GridItem
            as="nav"
            bg="white"
            borderRight="1px"
            borderRightColor="gray.200"
            pos={{ base: 'fixed', md: 'static' }}
            h="100%"
            display={{ base: 'none', md: 'block' }}
            w={sidebarWidth}
          >
            <Sidebar onClose={onClose} />
          </GridItem>

          {/* Mobile Drawer */}
          <Drawer
            isOpen={isOpen}
            placement="left"
            onClose={onClose}
            returnFocusOnClose={false}
            onOverlayClick={onClose}
            size="full"
          >
            <DrawerContent>
              <Sidebar onClose={onClose} />
            </DrawerContent>
          </Drawer>

          {/* Content */}
          <GridItem
            colStart={{ base: 1, md: 2 }}
            as="main"
            height="100%"
            display="flex"
            flexDirection="column"
            width={'100%'}
          >
            <Container
              maxW="1300px"
              px={{ base: 4, md: 6 }}
              py={{ base: 6, md: 8 }}
              flex="1"
              display="flex"
              flexDirection="column"
              height="100%"
              width={'100%'}
            >
              {children}
            </Container>
          </GridItem>
        </Grid>
      </Box>
    </Box>
  );
};

export default Layout;
